import { Component, OnInit } from '@angular/core';
import {CUSTOM_MAP_STYLE} from '../../util/map-style';

@Component({
  selector: 'app-contact-section',
  templateUrl: './contact-section.component.html',
  styleUrls: ['./contact-section.component.scss']
})
export class ContactSectionComponent implements OnInit {

  contactMap: any;
  customGoogleMapStyle: any;


  constructor() {

    this.customGoogleMapStyle = CUSTOM_MAP_STYLE;

  }

  onMapReady(map) {
    this.contactMap = map;
    this.contactMap.styles = this.customGoogleMapStyle;
  }

  ngOnInit() {
  }

}
